module.exports = __webpack_public_path__ + "static/media/office3.55836d3f.jpg";